(() => {
  'use strict';
  if (window.PinmeNativeContent) return;
  const roots = new Map();
  const selector = '[data-native-product],[data-native-product-story],[data-native-content]';
  const nodes = scope => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function mount(scope = document) {
    nodes(scope).forEach(root => {
      if (roots.has(root)) return;
      const controller = new AbortController();
      const signal = controller.signal;
      const disposal = [];
      roots.set(root, () => { controller.abort(); disposal.forEach(fn => fn()); roots.delete(root); });
      if (root.matches('[data-native-product]')) {
        let request = null;
        let serial = 0;
        const strings = JSON.parse(root.querySelector('[data-native-product-strings]')?.textContent || '{}');
        root.addEventListener('change', async event => {
          if (!event.target.matches('[data-option-value-id]')) return;
          const pendingForm=root.querySelector('form[action*="/cart/add"],[data-email-interest-form]');
          if(pendingForm?.dataset.pinmePending==='true'||pendingForm?.dataset.emailInterestState==='pending') {
            root.querySelectorAll('[data-option-value-id]').forEach(input=>input.checked=input.defaultChecked);
            return;
          }
          const sequence = ++serial;
          request?.abort(); request = new AbortController();
          const form = root.querySelector('form[action*="/cart/add"],.pinme-native-launch');
          const status = root.querySelector('[data-native-product-status]');
          const values = [...root.querySelectorAll('[data-option-value-id]:checked')].map(input => input.dataset.optionValueId);
          const optionId = event.target.dataset.optionValueId;
          const url = new URL(root.dataset.productUrl, location.origin);
          url.searchParams.set('section_id', root.hasAttribute('data-native-product-embedded') ? 'pinme-product-main' : root.dataset.sectionId);
          url.searchParams.set('option_values', values.join(','));
          root.dataset.pinmeVariantPending = 'true';
          form.inert = true; root.setAttribute('aria-busy', 'true'); status.textContent = '';
          try {
            const response = await fetch(url, {signal: request.signal});
            if (!response.ok) throw Error('Product selection unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const replacement = html.querySelector('[data-native-product]');
            if (!replacement) throw Error('Product selection unavailable');
            if (!root.isConnected || sequence !== serial) return;
            const selected = replacement.querySelector('[data-variant-id]');
            const nextAdd = replacement.querySelector('button[name="add"]');
            if (!selected || (!/^\d+$/.test(selected.value) && !(selected.value === '' && nextAdd?.disabled))) throw Error('Product selection unavailable');
            if (root.hasAttribute('data-native-product-embedded') || replacement.dataset.productUrl === root.dataset.productUrl) {
              const nextOptions = replacement.querySelector('[data-native-options]');
              const currentOptions = root.querySelector('[data-native-options]');
              const currentVariant = root.querySelector('[data-variant-id]');
              const add = root.querySelector('button[name="add"]');
              const nextPrice = replacement.querySelector('[data-pinme-main-price]');
              const currentPrice = root.querySelector('[data-pinme-main-price]');
              const quantity = root.querySelector('[name="quantity"]');
              const nextQuantity = replacement.querySelector('[name="quantity"]');
              const nextInterest = replacement.querySelector('[data-email-interest-config]');
              const currentInterest = root.querySelector('[data-email-interest-config]');
              const nextValues = [...(nextOptions?.querySelectorAll('[data-option-value-id]:checked') || [])].map(input => input.dataset.optionValueId);
              if (!nextOptions || !currentOptions || !currentVariant || (add && !nextAdd) || (currentPrice && !nextPrice) || (quantity && !nextQuantity) || (currentInterest && !nextInterest && !root.hasAttribute('data-native-product-embedded')) || nextValues.length !== values.length || values.some(value => !nextValues.includes(value))) throw Error('Product selection unavailable');
              currentOptions.replaceWith(nextOptions);
              if (nextPrice) {
                const hideLaunchZero = root.dataset.comingSoon === 'true' && nextPrice.dataset.priceCents === '0';
                nextPrice.hidden = hideLaunchZero;
                if (hideLaunchZero) nextPrice.style.setProperty('display', 'none');
                else nextPrice.style.removeProperty('display');
                currentPrice?.replaceWith(nextPrice);
              }
              const mediaId = selected.dataset.mediaId || replacement.querySelector('[data-main-slide]')?.dataset.mediaId || '';
              currentVariant.value = selected.value;
              currentVariant.dataset.mediaId = mediaId;
              const available = nextAdd ? !nextAdd.disabled : undefined;
              const stockStatus = root.querySelector('.pinme-native-product__status');
              const nextStockStatus = replacement.querySelector('.pinme-native-product__status,[data-stock-text]');
              if (stockStatus && nextStockStatus) stockStatus.textContent = nextStockStatus.textContent;
              if (typeof available === 'boolean') {
                const configNode = root.querySelector('[data-fulfillment-config]');
                if (configNode) {
                  try {
                    const config = JSON.parse(configNode.textContent);
                    const variant = config.variants?.find(item => String(item.id).split('/').pop() === selected.value);
                    if (variant) { variant.available = available; configNode.textContent = JSON.stringify(config); }
                  } catch (_) {}
                }
              }
              if (nextInterest && currentInterest && !root.hasAttribute('data-native-product-embedded')) { currentInterest.replaceWith(nextInterest); window.PinmeEmailInterests?.refresh(root.querySelector('[data-email-interest-form]')); }
              if (root.dataset.comingSoon !== 'true') {
                if (add && nextAdd) { add.disabled = nextAdd.disabled; add.replaceChildren(...nextAdd.childNodes); }
                const payment = root.querySelector('.shopify-payment-button');
                if (payment && nextAdd) payment.hidden = nextAdd.disabled;
                if (quantity && nextQuantity) {
                  quantity.min = nextQuantity.min; quantity.step = nextQuantity.step; quantity.max = nextQuantity.max;
                  const min = Number(quantity.min || 1), step = Number(quantity.step || 1), max = Number(quantity.max || Infinity);
                  quantity.value = String(Math.min(min + Math.floor((max - min) / step) * step, min + Math.max(0, Math.ceil((Number(quantity.value) - min) / step)) * step));
                }
              }
              root.dispatchEvent(new CustomEvent('pinme:variant-change', {detail: {variantId: selected.value, available}}));
              currentVariant.dispatchEvent(new Event('change', {bubbles: true}));
              const historyURL = new URL(location.href);
              if (selected.value) historyURL.searchParams.set('variant', selected.value); else historyURL.searchParams.delete('variant');
              history.replaceState(history.state, '', historyURL);
              if (mediaId) root.dispatchEvent(new CustomEvent('studio:select-media', { detail: { mediaId } }));
              root.querySelector('[data-option-value-id="' + optionId + '"]')?.focus({ preventScroll: true });
              status.textContent = '';
              return;
            }
            const wrapper = root.closest('.shopify-section') || root;
            const summary = root.querySelector('.ppr-summary-link');
            if (summary && !replacement.querySelector('.ppr-summary-link')) replacement.querySelector('.pinme-product-main__title-row')?.append(summary.cloneNode(true));
            const quantity = root.querySelector('[name="quantity"]')?.value;
            const nextQuantity = replacement.querySelector('[name="quantity"]');
            if (nextQuantity && quantity) {
              const min=Number(nextQuantity.min || 1),step=Number(nextQuantity.step || 1),max=Number(nextQuantity.max || Infinity);
              const stepped=min+Math.max(0,Math.ceil((Number(quantity)-min)/step))*step;
              nextQuantity.value=String(Math.min(min+Math.floor((max-min)/step)*step,stepped));
            }
            wrapper.dispatchEvent(new CustomEvent('shopify:section:unload', {bubbles: true}));
            root.replaceWith(replacement);
            mount(replacement); window.PinmeStudioMedia?.init(replacement);
            wrapper.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true}));
            if (selected?.value) {
              const historyURL = new URL(location.href); historyURL.searchParams.set('variant', selected.value); history.replaceState({}, '', historyURL);
              if (selected.dataset.mediaId) replacement.dispatchEvent(new CustomEvent('studio:select-media', {detail: {mediaId: selected.dataset.mediaId}}));
            }
            replacement.querySelector('[data-option-value-id="' + optionId + '"]')?.focus({preventScroll: true});
          } catch (error) {
            if (error.name !== 'AbortError' && root.isConnected && sequence === serial) {
              root.querySelectorAll('[data-option-value-id]').forEach(input => input.checked = input.defaultChecked);
              status.textContent = strings.error || '';
            }
          } finally {
            if (root.isConnected && sequence === serial) {delete root.dataset.pinmeVariantPending; form.inert = false; root.setAttribute('aria-busy', 'false');}
          }
        }, {signal});
        root.addEventListener('click', event => {
          const button = event.target.closest('[data-native-quantity]');
          if (!button) return;
          const input = root.querySelector('[name="quantity"]');
          if(root.querySelector('form')?.dataset.pinmePending==='true')return;
          input.stepUp(Number(button.dataset.nativeQuantity));
          input.dispatchEvent(new Event('change', {bubbles: true}));
        }, {signal});
        disposal.push(() => request?.abort());
      }
      if (root.matches('[data-native-product-story]')) {
        const canvas = root.querySelector('.psd-product-story__canvas');
        const outro = root.querySelector('.psd-product-story__outro');
        const originalOutro = outro.textContent;
        let lastWidth = -1, phoneLines;
        const lerp = (a, b, p) => a + (b - a) * p;
        const render = () => {
          const width = root.clientWidth;
          if (!width || Math.abs(width - lastWidth) < .1) return;
          lastWidth = width;
          const p = Math.max(0, Math.min(1, (width - 390) / 1050));
          const growth = 1 + Math.min(.2, Math.max(0, width - 1440) / 4000);
          const scale = width <= 1440 ? 1 : growth;
          const shift = Math.min(0, (width - 390) / 2);
          const style = getComputedStyle(root);
          const number = (name, fallback) => Number(style.getPropertyValue(name).trim()) || fallback;
          const vars = {
            'canvas-width': width <= 1440 ? width : 1440 * growth,
            'canvas-height': lerp(582, 595, p) * scale,
            'art-x': (lerp(-288, 267, p) + shift) * scale,'art-y':lerp(-4,5,p)*scale,
            'art-width':929*scale,'art-height':560*scale,
            'title-x':lerp(15.377,384.777,p)*scale,'title-y':lerp(78.6,147.4,p)*scale,'title-width':275,
            'title-size':lerp(number('--native-story-heading-mobile',20),number('--native-story-heading',24),p),
            'intro-x':lerp(15.678,387.198,p)*scale,'intro-y':lerp(189,272,p)*scale,'intro-width':lerp(182.695,373.015,p),
            'body-size':lerp(number('--native-story-body-mobile',16),number('--native-story-body',20),p),'body-tracking':lerp(.2,.1,p),
            'outro-x':(lerp(163.845,655.245,p)+lerp(208.543,424.436,p))*scale-lerp(208.543,424.436,p),'outro-y':lerp(420,424,p)*scale,'outro-width':lerp(208.543,424.436,p),
            'tape-x':lerp(292,1020,p)*scale,'tape-y':lerp(8,9,p)*scale,'tape-width':lerp(83,135,p)*scale,'tape-height':lerp(57,92,p)*scale,
            'barcode-x':lerp(12,351,p)*scale,'barcode-y':lerp(465,454,p)*scale,'barcode-width':lerp(48,60,p)*scale,'barcode-height':lerp(105,130,p)*scale
          };
          if (width < 390) vars['outro-x'] = Math.max(16,width-vars['outro-width']-17.612);
          for (const [name,value] of Object.entries(vars)) canvas.style.setProperty('--story-'+name,value.toFixed(3)+'px');
          if (phoneLines !== (width <= 430)) {
            phoneLines = width <= 430;
            if (phoneLines && originalOutro === 'adding color, attitude, and a little trouble wherever she goes.') {
              outro.replaceChildren(...['adding color, attitude, and ','a little trouble wherever ','she goes.'].map(text => {const span=document.createElement('span');span.className='psd-product-story__phone-line';span.textContent=text;return span;}));
            } else outro.textContent = originalOutro;
          }
        };
        render(); let storyFrame = 0;
        const observer = new ResizeObserver(() => {
          if (storyFrame || signal.aborted) return;
          storyFrame = requestAnimationFrame(() => { storyFrame = 0; if (!signal.aborted) render(); });
        });
        observer.observe(root); disposal.push(() => { observer.disconnect(); if (storyFrame) cancelAnimationFrame(storyFrame); });
      }
      if (root.matches('[data-native-content]')) {
        root.querySelectorAll('[data-native-faq]').forEach(faq => {
          const list = faq.querySelector('[data-native-faq-list]');
          const toggle = faq.querySelector('[data-native-faq-toggle]');
          if (!list || !toggle) return;
          const questions = [...list.querySelectorAll(':scope > details')];
          const visible = Math.max(1, Number(faq.dataset.faqVisible) || 4);
          if (questions.length <= visible) return;
          const remaining = questions.slice(visible);
          const update = expanded => {
            remaining.forEach(question => { question.hidden = !expanded; if (!expanded) question.open = false; });
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.querySelector('[data-faq-toggle-label]').textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
          };
          update(false); toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') !== 'true';
            const top = toggle.getBoundingClientRect().top;
            update(expanded);
            if (!expanded && top > 0 && toggle.getBoundingClientRect().top < 0) toggle.scrollIntoView({block:'center',behavior:'smooth'});
            toggle.focus({preventScroll:true});
          }, {signal});
          disposal.push(() => { remaining.forEach(question => { question.hidden = false; }); toggle.hidden = true; });
        });
        let fontWidth = -1;
        const saved = new Map();
        const typeNodes = [...root.querySelectorAll('h1,h2,h3,p,figcaption,mark')];
        typeNodes.forEach(node => saved.set(node,node.style.fontSize));
        const fonts = () => {
          if (Math.abs(root.clientWidth-fontWidth)<.1) return;
          fontWidth=root.clientWidth;
          typeNodes.forEach(node => node.style.fontSize=saved.get(node));
          const style=getComputedStyle(root);
          const headingScale=Number(style.getPropertyValue('--native-current-heading-scale').trim())||1;
          const bodyScale=Number(style.getPropertyValue('--native-body-scale').trim())||1;
          const computed=typeNodes.map(node => [node,parseFloat(getComputedStyle(node).fontSize)]);
          computed.forEach(([node,size]) => {
            const heading=node.matches('h1,h2,h3,mark,.psd-mumuse-world__day');
            const scale=heading?headingScale:bodyScale;
            if(scale!==1) node.style.fontSize=(size*scale).toFixed(3)+'px';
          });
        };
        fonts();const typeObserver=new ResizeObserver(fonts);typeObserver.observe(root);disposal.push(()=>typeObserver.disconnect());
        root.addEventListener('click', event => {
          const button = event.target.closest('[data-native-image]');
          if (!button || !root.contains(button) || !window.PinmeStudioMedia) return;
          const buttons = [...root.querySelectorAll('[data-native-image]')];
          const originals = buttons.map(b => {
            const image = b.querySelector('img'), source = [...b.querySelectorAll('picture source[data-native-original]')].find(candidate => !candidate.media || matchMedia(candidate.media).matches);
            return {button:b,src:source?.dataset.nativeOriginal || image?.dataset.nativeOriginal || image?.currentSrc || image?.src,alt:image?.alt || '',caption:b.dataset.pmWayCaption || image?.alt || ''};
          }).filter(item => item.src);
          const index = originals.findIndex(item => item.button === button), items = originals.map(item => ({src:item.src,alt:item.alt,caption:item.caption}));
          window.PinmeStudioMedia.open(items,Math.max(0,index),button);
        }, {signal});
      }
    });
  }
  function unmount(scope) {nodes(scope).forEach(root => roots.get(root)?.());}
  window.PinmeNativeContent = {mount,unmount};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once:true}); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
})();
